var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlideLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 7h10a1 1 0 010 2H5v3L0 8l5-4v3zM8 3h7a1 1 0 000-2H8a1 1 0 000 2zm0 12h7a1 1 0 000-2H8a1 1 0 000 2z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik01IDdoMTBhMSAxIDAgMDEwIDJINXYzTDAgOGw1LTR2M3oiLz48cGF0aCBkPSJNOCAzaDdhMSAxIDAgMDAwLTJIOGExIDEgMCAwMDAgMnpNOCAxNWg3YTEgMSAwIDAwMC0ySDhhMSAxIDAgMDAwIDJ6Ii8+PC9nPjwvc3ZnPgo=";
export { SvgSlideLeft as ReactComponent };